
import React from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Edit, Trash } from 'lucide-react';
import { Translation } from '@/utils/translationUtils';
import TablePagination from '@/components/ui/TablePagination';

interface TranslationTableProps {
  translations: Translation[];
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onEdit: (translation: Translation) => void;
  onDelete: (key: string) => void;
  translateFn: (key: string) => string;
}

const TranslationTable: React.FC<TranslationTableProps> = ({
  translations,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  translateFn
}) => {
  return (
    <>
      <div className="border rounded-md">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{translateFn('translations.translationKey')}</TableHead>
              <TableHead>{translateFn('translations.english')}</TableHead>
              <TableHead>{translateFn('translations.norwegian')}</TableHead>
              <TableHead className="w-[100px] text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {translations.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} className="text-center py-8 text-muted-foreground">
                  {translateFn('translations.noTranslationsFound')}
                </TableCell>
              </TableRow>
            ) : (
              translations.map((translation) => (
                <TableRow key={translation.key} className="h-10">
                  <TableCell className="font-mono text-xs break-all py-2">
                    {translation.key}
                  </TableCell>
                  <TableCell className="max-w-[200px] truncate py-2">
                    {translation.en}
                  </TableCell>
                  <TableCell className="max-w-[200px] truncate py-2">
                    {translation.no}
                  </TableCell>
                  <TableCell className="text-right py-2">
                    <div className="flex justify-end gap-2">
                      <Button 
                        variant="ghost" 
                        size="icon"
                        onClick={() => onEdit(translation)}
                        className="h-7 w-7"
                      >
                        <Edit className="h-3.5 w-3.5" />
                      </Button>
                      <Button 
                        variant="ghost" 
                        size="icon"
                        onClick={() => onDelete(translation.key)}
                        className="h-7 w-7"
                      >
                        <Trash className="h-3.5 w-3.5" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>

      {translations.length > 0 && (
        <div className="flex justify-center mt-4">
          <TablePagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </>
  );
};

export default TranslationTable;
